type Theme = 'light' | 'dark';
type Option = 'background' | 'heading' | 'text';

const themeClasses: Record<Theme, Record<Option, string>> = {
  light: {
    background: '!bg-background-white',
    heading: '!text-heading-black',
    text: '!text-dark-gray',
  },
  dark: {
    background: '!bg-background-black',
    heading: '!text-heading-white',
    text: '!text-light-gray',
  },
};

export const getThemeClass = (theme: Theme, option: Option): string => {
  return themeClasses[theme][option];
};
